import moment from "moment";
import React, { SetStateAction, useContext, useEffect, useState } from "react";
import { Col, Button, Accordion, Spinner, Row, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { WidgetContext } from "../../../../../../../context/WidgetContext";
import Itinerary from "../../../../../../../Data/Itinerary";
import { Payment } from "../../../../../../../Data/Reservation/Payment";
import { PaymentAllocationCategory } from "../../../../../../../Data/Reservation/PaymentAllocationCategory";
import { ReservationCustomer } from "../../../../../../../Data/Reservation/ReservationCustomer";
import ReservationGuest from "../../../../../../../Data/Reservation/ReservationGuest";
import { Constants } from "../../../../../../../_helpers/Constants";
import ViewPort from "../../../../../../../_helpers/Enums/ViewPortEnum";
import useFetch, { FetchRequest } from "../../../../../../../_helpers/UseFetchHook";

interface props {
  index: number;
  reservationGuest: ReservationGuest;
  remainingReservationBalance: number;
  // reservationCustomer?: ReservationCustomer;
  onJoinClicked: (guest: any) => void;
  onPayClicked: (index: number) => void;
  isLoading: boolean;
  errors: { join: boolean, name: boolean, email: boolean, index: number };
  paymentCategories: PaymentAllocationCategory[] | undefined;
  itinerary: Itinerary;
  reservationGuests: ReservationGuest[];
  isQuoteExpired: boolean;
}

const GuestInfo: React.FC<props> = (props) => {
  const { style, viewPortBreakPoint } = useContext(WidgetContext);
  const { index, remainingReservationBalance, onJoinClicked, onPayClicked, isLoading, errors, paymentCategories, itinerary } = props;
  const [reservationGuest, setReservationGuest] = useState<ReservationGuest>(props.reservationGuest);
  const [newGuestName, setNewGuestName] = useState<string>();
  const [newGuestEmail, setNewGuestEmail] = useState<string>();

  const isNewGuest = reservationGuest.name === undefined;

  const [emailCustomerRequest, setEmailCustomerRequest] = useState<FetchRequest>();
  const emailCustomerResponse = useFetch(emailCustomerRequest);
  // const fetchErrors = emailCustomerResponse.error.errors;
  const [paymentCategory, setPaymentCategory] = useState<PaymentAllocationCategory | undefined>((isNewGuest && paymentCategories) ? paymentCategories.find(c => c.categoryName === "Even Split") : undefined);
  const [customerCategory, setCustomerCategory] = useState<PaymentAllocationCategory | undefined>((reservationGuest.paymentAllocationCategoryId && paymentCategories) ? paymentCategories.find(c => c.paymentAllocationCategoryId === reservationGuest.paymentAllocationCategoryId) : paymentCategory);
  const evenCategory = !!props.paymentCategories ? props.paymentCategories.find(a => a.categoryName === "Even Split") : undefined;

  // const [balance, setBalance] = useState(reservationGuest.balanceDue);
  // const [price, setPrice] = useState(reservationGuest.price);

  function emailPayLink() {
    setEmailCustomerRequest({ url: `${Constants.apiUrl}/api/v1.0/reservations/${reservationGuest.reservationId}/customers/${reservationGuest.customerId}/email`, method: 'POST', body: {} });
  }

  useEffect(() => {
    // console.log("reservation guest", reservationGuest);

    setReservationGuest(props.reservationGuest)
  }, [props.reservationGuest]);

  useEffect(() => {
    if (!!!reservationGuest) return;

    // console.log("state reservation guest", reservationGuest);
    setCustomerCategory((reservationGuest.paymentAllocationCategoryId && paymentCategories) ? paymentCategories.find(c => c.paymentAllocationCategoryId === reservationGuest.paymentAllocationCategoryId) : paymentCategory);
  }, [reservationGuest]);

  useEffect(() => {
    if (!emailCustomerResponse.data) {
      return;
    }
    toast.success(emailCustomerResponse.data.message);
  }, [emailCustomerResponse.data]);

  // useEffect(() => {
  //   if (!emailCustomerResponse.error) {
  //     return;
  //   }

  //   // console.log("emailCustomerResponse", emailCustomerResponse.error);

  //   // if (fetchErrors && Object.keys(fetchErrors).length) {
  //   //   const errorsList = Object.values(fetchErrors).flat();
  //   //   toast.error(errorsList.join('. '));
  //   // } else if (emailCustomerResponse.error.message) {
  //   //   toast.error(emailCustomerResponse.error.message);
  //   // }

  // }, [emailCustomerResponse.error]);

  return (
    <React.Fragment>
      {/* Desktop */}
      {viewPortBreakPoint >= ViewPort.md && (
        <Col className="">
          <div
            className="m-0 p-0 w-100 d-flex flex-row justify-content-between"
            style={{ marginTop: "10px" }}
          >
            <Col
              xs={6}
              className="m-0 p-0 d-flex flex-row justify-content-between"
            >
              <Col xs={4} className="itinerary-label-text m-0 p-0 pt-2">
                {!isNewGuest && (
                  <>
                    <p className="m-0 p-0" style={{ color: style.fontColor }}>{reservationGuest.name}</p>
                    <Accordion defaultActiveKey="0">
                      <Accordion.Toggle
                        as={Button}
                        style={{ paddingLeft: "0px" }}
                        variant="link"
                        eventKey="0"
                      >
                        <p
                          className="itinerary-label-text d-flex flex-row justify-content-start"
                          style={{ minWidth: "200px" }}
                        >
                          Payments History
                        </p>
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey="0">
                        <Col
                          style={{ marginLeft: "15px", minWidth: "200px" }}
                          className="itinerary-label-text green-text"
                        >
                          {reservationGuest.payments.map((p: Payment) =>
                            <p className={`${(p.status === "Canceled" ? "red-text line-through" : "")}`}>${`${p.paymentAmount.toFixed(2)} - ${moment.utc(p.paymentDate).local().format("MMMM Do, YYYY")}`}</p>
                          )}
                        </Col>
                      </Accordion.Collapse>
                    </Accordion>
                  </>
                )}

                {reservationGuest.name === undefined && (
                  <Col className="m-0 p-0">
                    <Form.Control
                      className="text-center"
                      style={{ fontSize: "14px" }}
                      name="name"
                      placeholder="Enter Name To Join"
                      onChange={(e: any) => setNewGuestName(e.target.value)}
                      isValid={!errors.name && errors.join && errors.index === index}
                      isInvalid={errors.join && errors.name && errors.index === index}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors && errors.name && (
                        <span className="red-text font-italic">Invalid Name</span>
                      )}
                    </Form.Control.Feedback>
                  </Col>
                )}
              </Col>
              <Col xs={4} className="itinerary-label-text pt-2">
                {reservationGuest.email !== undefined && (
                  <p className="m-0 p-0" style={{ color: style.fontColor }}>
                    {reservationGuest.email}
                  </p>
                )}

                {reservationGuest.email === undefined && (
                  <Col className="m-0 p-0">
                    <Form.Control
                      className="text-center"
                      style={{ fontSize: "14px" }}
                      name="email"
                      placeholder="Enter Email Address"
                      onChange={(e: any) => setNewGuestEmail(e.target.value)}
                      isValid={!!!errors.email && errors.join && errors.index == index}
                      isInvalid={errors.join && errors.email && errors.index == index}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors && errors.name && (
                        <span className="red-text font-italic">Invalid Email</span>
                      )}
                    </Form.Control.Feedback>
                  </Col>
                )}
              </Col>
              <Col xs={4} className="itinerary-label-text text-center pt-2">
                <p className="m-0 p-0" style={{ color: style.fontColor }}>
                  {customerCategory ? customerCategory.categoryName : (evenCategory !== undefined ? "Even Split" : "N/A")}
                </p>
              </Col>
            </Col>

            <Col className="ml-1 ml-lg-5">
              {isNewGuest && (
                <Button
                  disabled={props.isQuoteExpired}
                  className="pay-button"
                  onClick={() => onJoinClicked({ name: newGuestName, email: newGuestEmail, index: index, categoryId: customerCategory ? customerCategory.paymentAllocationCategoryId : undefined })}
                >
                  {isLoading && (<Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />)}
                  {!isLoading && "Join"}
                </Button>
              )}
              {(!isNewGuest && !reservationGuest.cancelled) && (
                <Button disabled={props.isQuoteExpired} className="pay-button" onClick={() => onPayClicked(index)}>Pay</Button>
              )}
              {!reservationGuest.cancelled && (
                <Button className="email-button" onClick={emailPayLink} disabled={props.isQuoteExpired || reservationGuest.email === undefined || reservationGuest.email === ""}>
                  <Row className="justify-content-center align-items-center">
                    {(emailCustomerResponse.isLoading) && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    {(emailCustomerResponse.isLoading) ? "Emailing..." : "Email Pay Link"}
                  </Row>
                </Button>
              )}
            </Col>

            {!reservationGuest.cancelled && (
              <Col
                xs={3}
                className="d-flex flex-row justify-content-between payment-row-right pt-2"
              >
                <Col
                  className="d-flex justify-content-start itinerary-label-text red-text"
                  style={{ paddingLeft: "0px", marginLeft: "21px" }}
                >
                  {/* ${Math.min(reservationGuest.balanceDue, remainingReservationBalance).toFixed(2)} */}
                  ${reservationGuest.balanceDue.toFixed(2)}
                </Col>
                <Col className="d-flex justify-content-center itinerary-label-text green-text">
                  ${(reservationGuest.paymentsAmount).toFixed(2)}{reservationGuest.tipAmount > 0 && (<>{` + Tip`}</>)}
                </Col>
                <Col
                  className="d-flex justify-content-end itinerary-label-text font-weight-bold green-text"
                  style={{ paddingRight: "0px" }}
                >
                  ${reservationGuest.price.toFixed(2)}
                </Col>
              </Col>
            )}
          </div>
        </Col>
      )}

      {/* Mobile */}
      {viewPortBreakPoint < ViewPort.md && (
        <Col className="m-0 p-0">
          <Accordion className="m-0 p-0">
            <Row>
              <Accordion.Toggle as={Button} variant="link" eventKey="0" className="m-0 p-0 mt-2">
                <p
                  className="itinerary-label-text d-flex flex-row justify-content-start"
                  style={{ minWidth: "200px" }}
                >
                  {`${(reservationGuest.name ? reservationGuest.name : "Click to Join")} - ${(customerCategory ? customerCategory.categoryName : "Even Split")}`}
                </p>
              </Accordion.Toggle>
              {(!isNewGuest && !reservationGuest.cancelled) && (
                <Button disabled={props.isQuoteExpired} size="sm" className="pay-button ml-auto mr-0" onClick={() => onPayClicked(index)}>Pay</Button>
              )}
            </Row>

            <Accordion.Collapse eventKey="0">
              <Col
                style={{ marginLeft: "0px", minWidth: "200px" }}
                className="itinerary-label-text"
              >
                <Col xs={12} className="d-flex flex-row">
                  {/* Left Col */}
                  <Col xs={6} className="ml-3">
                    {isNewGuest && (
                      <p style={{ marginTop: isNewGuest ? "0px" : "0px" }}
                      >
                        Enter Name:
                      </p>
                    )}
                    <p className={` ${(isNewGuest ? "" : "")}`}
                    >
                      Email:
                    </p>
                    <p
                      className={``}
                      style={{ marginTop: isNewGuest ? "18px" : "10px" }}
                    >
                      Category:
                    </p>
                    <p
                      className={``}
                      style={{ marginTop: "10px" }}
                    >
                      Balance:
                    </p>
                    <p
                      className={``}
                      style={{ marginTop: "10px" }}
                    >
                      Paid:
                    </p>
                    <p
                      className={``}
                      style={{ marginTop: "10px" }}
                    >
                      Price:
                    </p>
                    <p
                      className=""
                      style={{ marginTop: "10px" }}
                    />
                    <p className="">
                      {isNewGuest && (
                        <Button
                          disabled={props.isQuoteExpired}
                          className="pay-button"
                          onClick={() => onJoinClicked({ name: newGuestName, email: newGuestEmail, index: index, categoryId: customerCategory ? customerCategory.paymentAllocationCategoryId : undefined })}
                        >
                          {isLoading && (<Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />)}
                          {!isLoading && "Join"}
                        </Button>
                      )}
                      {(!isNewGuest && !reservationGuest.cancelled) && (
                        <Button disabled={props.isQuoteExpired} className="pay-button" onClick={() => onPayClicked(index)}>Pay</Button>
                      )}
                    </p>

                    {/* Payment History */}
                    {!isNewGuest && (
                      <Accordion defaultActiveKey="0" className="m-0 p-0">
                        <Accordion.Toggle as={Button} variant="link" eventKey="0" className="m-0 p-0">
                          <p
                            className="itinerary-label-text d-flex flex-row justify-content-start"
                            style={{ minWidth: "200px" }}
                          >
                            Payments History
                          </p>
                        </Accordion.Toggle>

                        <Accordion.Collapse eventKey="0">
                          <Col
                            style={{ marginLeft: "15px", minWidth: "200px" }}
                            className="itinerary-label-text green-text"
                          >
                            {reservationGuest.payments.map((p: Payment) =>
                              <p className={`${(p.status === "Canceled" ? "red-text line-through" : "")}`}>${`${p.paymentAmount.toFixed(2)} - ${moment(p.paymentDate).format("MMMM Do, YYYY")}`}</p>
                            )}
                          </Col>
                        </Accordion.Collapse>
                      </Accordion>
                    )}
                  </Col>
                  {/* Right Col */}
                  <Col xs={6}>
                    {reservationGuest.name == undefined && (
                      <Col className="m-0 p-0">
                        <Form.Control
                          className="text-center"
                          style={{ fontSize: "14px", marginTop: "-5px" }}
                          name="name"
                          placeholder="Enter Name To Join"
                          onChange={(e: any) => setNewGuestName(e.target.value)}
                          isValid={!!!errors.name && errors.join && errors.index === index}
                          isInvalid={errors.join && errors.name && errors.index === index}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors && errors.name && (
                            <span className="red-text font-italic">Invalid Name</span>
                          )}
                        </Form.Control.Feedback>
                      </Col>
                    )}
                    <p>
                      {reservationGuest.email != undefined && (
                        <p className="m-0 p-0" style={{ color: style.fontColor }}>
                          {reservationGuest.email}
                        </p>
                      )}

                      {reservationGuest.email === undefined && (
                        <Col className="m-0 p-0">
                          <Form.Control
                            size="sm"
                            className="text-center"
                            style={{ fontSize: "14px" }}
                            name="email"
                            placeholder="Enter Email Address"
                            onChange={(e: any) => setNewGuestEmail(e.target.value)}
                            isValid={!!!errors.email && errors.join && errors.index == index}
                            isInvalid={errors.join && errors.email && errors.index == index}
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors && errors.name && (
                              <span className="red-text font-italic">Invalid Email</span>
                            )}
                          </Form.Control.Feedback>
                        </Col>
                      )}
                    </p>
                    <p style={{ marginTop: "10px" }}>{customerCategory ? customerCategory.categoryName : "Even Split"}</p>
                    <p style={{ marginTop: "10px", color: "red" }}>${reservationGuest.balanceDue.toFixed(2)}</p>
                    <p className="green-text" style={{ marginTop: "10px" }}>
                      ${(reservationGuest.paymentsAmount).toFixed(2)}{reservationGuest.tipAmount > 0 && (<>{` + Tip`}</>)}
                    </p>
                    <p className="green-text" style={{ marginTop: "10px" }}>
                      ${reservationGuest.price.toFixed(2)}
                    </p>
                    <p
                      style={{ marginTop: "10px", paddingLeft: "0px" }}
                      className="d-flex flex-row justify-content-start"
                    >
                      <Button disabled={isNewGuest} className="email-button" onClick={emailPayLink}>
                        <Row className="justify-content-center align-items-center">
                          {(emailCustomerResponse.isLoading) && (
                            <Spinner
                              className="mr-2"
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                          {(emailCustomerResponse.isLoading) ? "Emailing..." : "Email Pay Link"}
                        </Row>
                      </Button>
                    </p>
                  </Col>
                </Col>
              </Col>
            </Accordion.Collapse>
          </Accordion>
        </Col>
      )}
    </React.Fragment>
  );
}

export default GuestInfo;